import React from 'react';
import { styled } from '@linaria/react';
import { Text } from '@vio/atlas/Text';
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage';
const LegendWrapper = /*#__PURE__*/styled('div')({
  name: "LegendWrapper",
  class: "l1kmyj9j",
  propsAsIs: false
});
const LegendBox = /*#__PURE__*/styled('div')({
  name: "LegendBox",
  class: "l12i88xt",
  propsAsIs: false
});
export const Legend = () => {
  return <LegendWrapper>
      <LegendBox />
      <Text variant="bodyXS" colorPath="content.neutral.c600">
        <FormattedMessageWrapper id="cheapestNightlyPrice" defaultMessage="Cheapest nightly price" />
      </Text>
    </LegendWrapper>;
};

require("./Legend.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Legend.tsx");